<template>
  <div class="onboarding-signup-step-seats">
    <VeeForm ref="form" @submit="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title-optional">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.INFO.SEATS.@TITLE")) }}
            <ExtraTag :label="$t('ETAB.BUTTONS.@OPTIONAL')" />
          </h2>

          <Seats v-model:seats="seats" :i-model="ISignup" />
        </QPage>
      </transition>

      <QFooter>
        <div>
          <QBtn color="secondary" type="submit" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@NEXT')" no-caps />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>

<script setup>
  import { Form as VeeForm } from "vee-validate";
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { FIREBASE_EVENTS } from "@core/constants";
  import { onMounted, ref } from "vue";
  import { ISignup } from "@core/models";
  import { useSignup } from "@etab/composables";
  import { useTransition } from "@core/composables";
  import Seats from "@etab/components/onboarding/signup/Seats.component.vue";

  const { transition } = useTransition();
  const { $_nextStep } = useSignup();
  const signupStore = useSignupStore();

  const form = ref({ seats: "" });

  const onSubmit = async function () {
    TrackingManager.addEvent({
      event: FIREBASE_EVENTS.FUNNEL_SECOND_STEP,
      step: "step2_seats",
    });
    signupStore[ACTION_SIGNUP_UPDATE]({ [ISignup.seats]: form.value.seats });
    $_nextStep();
  };

  onMounted(() => {
    form.value.seats = signupStore[GETTER_SIGNUP_GET][ISignup.seats] || null;
  });
</script>
